export const getHeaderClasses = (level: number, textClass: string = '') => {
    switch (level) {
      case 2: return `${textClass} text-3xl`;
      case 3: return `${textClass} text-2xl`;
      case 4: return `${textClass} text-xl`;
      case 5: return `${textClass} text-lg`;
      case 6: return `${textClass} text-base`;
      default: return '';
    }
  };

const HEADER_LEVELS = [2, 3, 4, 5, 6] as const;

export const getHeaderClassesMap = (
  buildClasses: (level: number) => string
): Record<string, string> =>
  Object.fromEntries(HEADER_LEVELS.map((level) => [`h${level}`, buildClasses(level)]));